import { render, staticRenderFns } from "./SettingDetailView.vue?vue&type=template&id=028c59ae&scoped=true&"
import script from "./SettingDetailView.vue?vue&type=script&lang=ts&"
export * from "./SettingDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c59ae",
  null
  
)

export default component.exports